import {
  action
} from './common';

export const types = {
  CONFIG_REQUEST: 'CONFIG/REQUEST',
  CONFIG_SUCCESS: 'CONFIG/SUCCESS',
  CONFIG_FAILURE: 'CONFIG/FAILURE',
};

export const actions = {
  request: () => action(types.CONFIG_REQUEST),
  success: config => action(types.CONFIG_SUCCESS, { config }),
  failure: error => action(types.CONFIG_FAILURE, { error }),
};

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.CONFIG_SUCCESS:
      return {
        ...action.config,
        policy_types: action.config.policy_types
      };
    case types.CONFIG_REQUEST:
    case types.CONFIG_FAILURE:
      return {};
    default:
      return state;
  }
}

export const getAvailablePolicyTypes = state => state.policy_types || [];



// WEBPACK FOOTER //
// ./src/reducers/config.js